import { Component, input } from '@angular/core';

/**
 * @description Note - styling of the fields projected into this component is defined in `styles.scss` of the app
 *              <ng-content> styling required heavy handed DOM stuff, either directives or global style sheet.
 *              Link to why and how in that file. If you need to target more than `mat-form-field`, add it there too.
 */
@Component({
    selector: 'r1-compass-lib-form-row',
    imports: [],
    template: `
        <div class="form-row-container">
            <span class="field-row-name"
                >{{ name() }}
                <ng-content select="[helperText]" />
                <ng-content select="[copy]" />
            </span>
            <ng-content />
        </div>
    `,
    styles: `
        .form-row-container {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 5px;
        }
        .field-row-name {
            max-width: 30%;
        }
    `,
})
export class FormRowComponent {
    name = input.required<string>();
}
